import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";
import { COMPANY, NAV } from "../lib/company";

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-50 bg-white border-b-2 border-black"
      data-testid="site-header"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="flex items-center justify-between h-20 lg:h-24">
          {/* Logo */}
          <Link
            to="/"
            className="flex items-center gap-3"
            data-testid="header-logo-link"
          >
            <img
              src={COMPANY.logoUrl}
              alt="Humlegruppen"
              className="h-12 lg:h-16 w-auto object-contain"
              data-testid="header-logo-image"
            />
          </Link>

          {/* Desktop Nav */}
          <nav
            className="hidden lg:flex items-center gap-10"
            data-testid="desktop-nav"
          >
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                data-testid={item.testid}
                className={({ isActive }) =>
                  `font-condensed uppercase tracking-[0.18em] text-sm font-bold transition-colors duration-200 relative py-2 ${
                    isActive
                      ? "text-black"
                      : "text-gray-700 hover:text-black"
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    {item.label}
                    {isActive && (
                      <span className="absolute -bottom-1 left-0 right-0 h-[3px] bg-[#FFD700]" />
                    )}
                  </>
                )}
              </NavLink>
            ))}
          </nav>

          {/* Phone CTA */}
          <a
            href={COMPANY.phoneHref}
            className="hidden lg:inline-flex items-center gap-2 bg-[#FFD700] text-black font-bold px-5 py-3 border-2 border-black hover:bg-yellow-400 transition-colors"
            data-testid="header-phone-cta"
          >
            <Phone size={18} strokeWidth={2.5} />
            <span className="font-condensed tracking-wider text-base">
              {COMPANY.phone}
            </span>
          </a>

          {/* Mobile burger */}
          <button
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden p-2 border-2 border-black"
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>

        {/* Mobile menu */}
        {open && (
          <div
            className="lg:hidden border-t-2 border-black py-4"
            data-testid="mobile-nav"
          >
            <nav className="flex flex-col gap-1">
              {NAV.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === "/"}
                  onClick={() => setOpen(false)}
                  data-testid={`${item.testid}-mobile`}
                  className={({ isActive }) =>
                    `font-condensed uppercase tracking-[0.18em] text-base font-bold px-3 py-3 border-l-4 ${
                      isActive
                        ? "text-black border-[#FFD700] bg-gray-50"
                        : "text-gray-700 border-transparent"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
              <a
                href={COMPANY.phoneHref}
                className="mt-3 inline-flex items-center justify-center gap-2 bg-[#FFD700] text-black font-bold px-5 py-3 border-2 border-black"
                data-testid="mobile-phone-cta"
              >
                <Phone size={18} strokeWidth={2.5} />
                <span className="font-condensed tracking-wider">
                  {COMPANY.phone}
                </span>
              </a>
            </nav>
          </div>
        )}
      </div>
      {/* Yellow accent line */}
      <div className="h-[3px] bg-[#FFD700] w-full" />
    </header>
  );
}
